(function () {
  'use strict';

  angular.module('wsLrs.services').factory("ViewDashboardsAs", [function () {
    return {
      isActive: false,
      selectedUser: null
    };
  }]);
})();
